(() => {
  const COMPONENT_NAME = 'vl-pdp-feature-drawer';
  const RUNTIME_VARIANT_ATTRIBUTE = 'data-vl-pdp-feature-drawer-variant';
  const ACTIVE_VARIANT_ATTRIBUTE = 'data-vl-pdp-feature-drawer-active-variant';
  const PREVIEW_QUERY_PARAMETER = 'vl_pdp_feature_drawer_variant';
  const MOBILE_MEDIA_QUERY = '(max-width: 767px)';
  const VALID_RUNTIME_VARIANTS = new Set(['a', 'b']);
  const VALID_PREVIEW_VARIANTS = new Set(['control', 'a', 'b']);

  if (customElements.get(COMPONENT_NAME)) return;

  class VLPdpFeatureDrawer extends HTMLElement {
    static get observedAttributes() {
      return [RUNTIME_VARIANT_ATTRIBUTE];
    }

    constructor() {
      super();
      this.isInitialized = false;
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKlaviyoForm = this.handleKlaviyoForm.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) return;

      this.trigger = document.querySelector(
        `[data-vl-pdp-feature-drawer-trigger][data-vl-pdp-feature-drawer-instance="${CSS.escape(this.dataset.vlPdpFeatureDrawerInstance || '')}"]`,
      );

      if (!this.trigger) return;

      document.addEventListener('click', this.handleDocumentClick);
      window.addEventListener('klaviyoForms', this.handleKlaviyoForm);
      this.applyVariant();
      this.isInitialized = true;
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;

      document.removeEventListener('click', this.handleDocumentClick);
      window.removeEventListener('klaviyoForms', this.handleKlaviyoForm);
      this.isInitialized = false;
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name !== RUNTIME_VARIANT_ATTRIBUTE || oldValue === newValue || !this.isConnected) return;
      this.applyVariant();
    }

    get previewVariant() {
      const value = new URLSearchParams(window.location.search)
        .get(PREVIEW_QUERY_PARAMETER)
        ?.trim()
        .toLowerCase();

      return VALID_PREVIEW_VARIANTS.has(value) ? value : '';
    }

    get runtimeVariant() {
      const value = (this.getAttribute(RUNTIME_VARIANT_ATTRIBUTE) || '').trim().toLowerCase();
      return VALID_RUNTIME_VARIANTS.has(value) ? value : '';
    }

    get defaultVariant() {
      return this.dataset.vlPdpFeatureDrawerDefaultVariant === 'a' ? 'a' : 'control';
    }

    get effectiveVariant() {
      return this.previewVariant || this.runtimeVariant || this.defaultVariant;
    }

    applyVariant() {
      if (!this.trigger) return;

      const variant = this.effectiveVariant;
      const controlId = this.dataset.vlPdpFeatureDrawerControlId;
      const experimentId = this.dataset.vlPdpFeatureDrawerExperimentId;
      const nextDrawerId = variant === 'control' ? controlId : experimentId;
      const keyFeature = document.querySelector(
        `[data-vl-pdp-key-feature][data-vl-pdp-key-feature-section-id="${CSS.escape(this.dataset.vlPdpFeatureDrawerSectionId || '')}"]`,
      );

      if (!nextDrawerId) return;

      this.setAttribute(ACTIVE_VARIANT_ATTRIBUTE, variant);
      this.trigger.dataset.sidebarId = nextDrawerId;
      this.trigger.setAttribute('aria-controls', nextDrawerId);
      this.updateTriggerLabel(variant);
      if (keyFeature) keyFeature.dataset.vlPdpKeyFeatureVariant = variant;
    }

    updateTriggerLabel(variant) {
      const labels = {
        control: this.dataset.vlPdpFeatureDrawerControlLabel,
        a: this.dataset.vlPdpFeatureDrawerALabel,
        b: this.dataset.vlPdpFeatureDrawerBLabel,
      };
      const label = labels[variant];

      if (!label) return;

      const title = this.trigger.querySelector(
        '.product-drawer-tabs-trigger-link__title, .product-drawer-tabs-trigger-button__title',
      );

      if (title) title.textContent = label;
      this.trigger.setAttribute('aria-label', label);
    }

    track(eventName) {
      // Queue events until the site's gtag loader is ready.
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };

      window.gtag('event', eventName, {
        experiment_variant: this.dataset.vlPdpFeatureDrawerActiveVariant || 'control',
        device: window.matchMedia(MOBILE_MEDIA_QUERY).matches ? 'mobile' : 'desktop',
        page_title: document.title,
      });
    }

    handleDocumentClick(event) {
      if (event.target.closest('[data-vl-pdp-feature-drawer-trigger]') === this.trigger) {
        this.track('pdp_spec_cta_click');
        return;
      }

      const guideCard = event.target.closest('[data-vl-pdp-feature-drawer-guidebook]');
      if (guideCard && guideCard.dataset.vlPdpFeatureDrawerInstance === this.dataset.vlPdpFeatureDrawerInstance) {
        this.track('pdp_guidebook_cta_click');
        this.openGuidebook(event);
        return;
      }

    }

    handleKlaviyoForm(event) {
      if (event.detail?.type !== 'submit') return;

      const formId = event.detail.formId;
      const isGuidebookForm = formId === this.dataset.vlPdpFeatureDrawerKlaviyoDesktopId
        || formId === this.dataset.vlPdpFeatureDrawerKlaviyoMobileId;

      if (isGuidebookForm) this.track('pdp_guidebook_submit');
    }

    openGuidebook(event) {
      event.preventDefault();

      const formId = window.matchMedia(MOBILE_MEDIA_QUERY).matches
        ? this.dataset.vlPdpFeatureDrawerKlaviyoMobileId
        : this.dataset.vlPdpFeatureDrawerKlaviyoDesktopId;

      if (!formId) return;

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }
  }

  customElements.define(COMPONENT_NAME, VLPdpFeatureDrawer);
})();
